


































































































































































































































































import { mapActions, mapGetters, mapState }     from 'vuex'
import { Vue, Component /* , Prop */, Watch }          from 'vue-property-decorator'
import { isObject, formatDate, formatDateHoursMinutes, formatDateSinTime, getFileNameFromHeader, base64ToArrayBuffer, format_phone_number }   from '@/utils/helpers'
import { Ability }                              from '@/types/Ability'
import _                                        from 'lodash'
import { Etat, getEtatSpecReclamation, TypeReclamation, TypeReponseReclamation }             from '@/types/Reclamation'
import ReclamationsOralGestion from '@/views/Reclamations/ReclamationsOralGestion.vue'
import  ErrorDisplay                            from '@/components/ErrorDisplay.vue'
import Back                                     from '@/components/Tools/Back.vue'
import PopupInfosEtDocumentsExaminateur from '@/views/Reclamations/PopupInfosEtDocumentsExaminateur.vue'

import { FontAwesomeIcon }              from '@fortawesome/vue-fontawesome'
import { etat_avis } from '@/types/ReclamationOral'


@Component({
    components: {
        ErrorDisplay,
        Back,
        ReclamationsOralGestion,
        PopupInfosEtDocumentsExaminateur,
        'font-awesome-icon': FontAwesomeIcon
    },
    computed: {
        ...mapState('reclamationOral', ['reclamationOralSelect', 'loading', 'error']),
        ...mapGetters('reclamationType', ['reclamationTypes']),
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA', 'user_session_id'])
    },
    methods: {
        ...mapActions('postes', ['getAllPostes'])
    }
})

export default class ReclamationOralGestion extends Vue {
    Ability                              = Ability
    reclamationSelectLocal: any          = {}
    etat_reclamation_select: any         = {}
    etat_avancement = Etat.ETAT_NON_TRAITE
    activerRectifiationNote              = false
    lockInput                            = false
    Etat                                 = Etat
    erreur_manqueNote: any               = null
    affichageChat: any                   = []
    connected_user                       = this.$store.state.auth.user
    showModalDemandeAvis                 = false
    examinateur: any = null
    centre: any = null
    formatDateHoursMinutes = formatDateHoursMinutes
    formatDateSinTime = formatDateSinTime
    etat_avis = etat_avis
    open_avis: any = null
    new_message = ''
    fileSingleFromInput: any = null
    hasSelectedFile = false

    formatPhoneNumber = format_phone_number

    reclamation_type_id = null

    reclamationTypesTemps: Array<any> = []

    @Watch('reclamationSelectLocal.decision')
    @Watch('etat_avancement')
    etatAvancementChangeHandler() {
        // console.log('--- etat_avancement : ' + this.etat_avancement)
        this.reclamationTypesTemps = this.$store.state.reclamationType.reclamationTypes
        if (this.etat_avancement === Etat.ETAT_REJETEE) {
            this.reclamationTypesTemps  = this.reclamationTypesTemps.filter((r: any) => r.type_reponse === TypeReponseReclamation.TYPE_REPONSE_REJETEE)
        } else if (this.etat_avancement === Etat.ETAT_TRAITE) {
            if (this.reclamationSelectLocal.decision) {
                this.reclamationTypesTemps  = this.reclamationTypesTemps.filter((r: any) => r.type_reponse === TypeReponseReclamation.TYPE_REPONSE_ACCEPTEE)
            } else {
                this.reclamationTypesTemps  = this.reclamationTypesTemps.filter((r: any) => r.type_reponse === TypeReponseReclamation.TYPE_REPONSE_REFUSEE)
            }
        }
        if (this.reclamationTypesTemps.length === 1) {
            this.reclamation_type_id = this.reclamationTypesTemps[0].id
        }
    }


    @Watch('user_session_id')
    retourMainPage () {
        this.$router.push('/reclamations_oral').catch(() => { console.log('catch redundant navigation reclamation_oral') })
    }

    popInfoExaminateurShow = false
    dataExaminateurTemp: any = null
    showPopInfoExaminateur () {
        this.dataExaminateurTemp = {
            examinateur: this.examinateur,
            centre: this.centre,
            matiere_id: this.reclamationSelectLocal.epreuve.matiere_id,
            ensemble: this.reclamationSelectLocal.seance ? this.$store.state.ensemble.ensembles.find((e: any) => e.id === this.reclamationSelectLocal.seance.creneau.ensemble_id) : null
        }
        this.popInfoExaminateurShow = true
    }

    /**
     * Aperçu de la fiche orale du candidat
     */
    voirFicheOral (item: any)
    {
        if (item && item.id !== undefined)
        {
            window.open(this.$store.getters['candidat/getCorrectionOnViatique'](item.id), '_blank')
        }
    }

    closePopInfoExaminateur () {
        this.dataExaminateurTemp = null
        this.popInfoExaminateurShow = false
    }

    /** Initialisation des datas */
    initInterface () {
        this.$store.dispatch('reclamationType/getReclamationTypes',  { 'filter-type_reclamation':  TypeReclamation.TYPE_PASSATION_ORAL }).then(() => {
            this.reclamationTypesTemps = this.$store.state.reclamationType.reclamationTypes
            this.initInterfaceSuite()
        })
    }

    initInterfaceSuite() {
        // console.log('---ReclamationOralGestion---initInterface----this.reclamationSelectLocal.validated_at : ' + this.reclamationSelectLocal.validated_at + '--')
        if (this.reclamationSelectLocal.validated_at) {
            this.lockInput = true
        } else {
            this.lockInput = false
        }

        // Récupération du nom de l'examinateur
        if (this.reclamationSelectLocal.seance && this.reclamationSelectLocal.seance.creneau) {
            const ensemble = this.$store.state.ensemble.ensembles.find((e: any) => e.id === this.reclamationSelectLocal.seance.creneau.ensemble_id)
            if (ensemble) {
                this.examinateur = ensemble.examinateurs.find((ex: any) => ex.id === this.reclamationSelectLocal.seance.creneau.user_id)
                if (!this.examinateur) {
                    this.examinateur = ensemble.remplacants.find((ex: any) => ex.id === this.reclamationSelectLocal.seance.creneau.user_id)
                }

                this.centre = this.reclamationSelectLocal.seance.creneau.ensemble.centre
            }
        }
        this.getEtatAvancementReclamation()
    }

    /** Check si la value est un objet */
    isObjectLocal (value: any) {
        return isObject(value)
    }

    /** Formattage de date */
    formatteDate (date: Date) {
        return formatDate(date)
    }

    /** récupère la couleur d'état d'avancement du traitement de la réclamation  */
    getEtatAvancementReclamation() {
        let etat = Etat.ETAT_NON_TRAITE

        // -----------

        switch(true) {

            case this.reclamationSelectLocal.rejected_at !== null:
                etat = Etat.ETAT_REJETEE
                this.etat_avancement = Etat.ETAT_REJETEE
                break
            case (this.reclamationSelectLocal.submitted_at === null &&  this.reclamationSelectLocal.validated_at === null) && (this.reclamationSelectLocal.note !== null || this.reclamationSelectLocal.message_gestionnaire !== null):
                etat = Etat.ETAT_EN_COURS
                this.etat_avancement = Etat.ETAT_NON_TRAITE
                break
            case this.reclamationSelectLocal.submitted_at !== null &&  this.reclamationSelectLocal.validated_at === null:
                etat = Etat.ETAT_TRAITE
                this.etat_avancement = Etat.ETAT_TRAITE
                break
            case this.reclamationSelectLocal.submitted_at !== null &&  this.reclamationSelectLocal.validated_at !== null:
                etat = Etat.ETAT_SIGNE
                this.etat_avancement = Etat.ETAT_SIGNE
                break
            case this.reclamationSelectLocal.submitted_at === null &&  this.reclamationSelectLocal.validated_at === null :
                etat = Etat.ETAT_EN_COURS
                this.etat_avancement = Etat.ETAT_NON_TRAITE
                break
        }

        // -----------
        /*
        if (!this.reclamationSelectLocal.submitted_at && !this.reclamationSelectLocal.validated_at) {
            etat = Etat.ETAT_NON_TRAITE
            this.etat_avancement = Etat.ETAT_NON_TRAITE
        }
        if ((!this.reclamationSelectLocal.submitted_at && !this.reclamationSelectLocal.validated_at && this.reclamationSelectLocal.message_gestionnaire) ||
        (!this.reclamationSelectLocal.submitted_at && !this.reclamationSelectLocal.validated_at && this.reclamationSelectLocal.etat === etat_avis.ETAT_PUBLIE_OBSERVATEUR)) {
            etat = Etat.ETAT_EN_COURS
            this.etat_avancement = Etat.ETAT_NON_TRAITE
        }
        if (this.reclamationSelectLocal.submitted_at && !this.reclamationSelectLocal.validated_at) {
            etat = Etat.ETAT_TRAITE
            this.etat_avancement = Etat.ETAT_TRAITE
        }
        if (this.reclamationSelectLocal.submitted_at && this.reclamationSelectLocal.validated_at) {
            etat = Etat.ETAT_SIGNE
            this.etat_avancement = Etat.ETAT_SIGNE
        }
        if (this.reclamationSelectLocal.rejected_at) {
            etat = Etat.ETAT_REJETEE
            this.etat_avancement = Etat.ETAT_REJETEE
        }
        */

        this.etat_reclamation_select = getEtatSpecReclamation(etat)
        this.reclamation_type_id = this.reclamationSelectLocal && this.reclamationSelectLocal.reclamationType ? this.reclamationSelectLocal.reclamationType.id : null
    }

    /** Retourne la liste passée en paramètre ordonnée par name */
    orderedListe (liste: any) {
        return _.orderBy(liste, 'name', 'asc')
    }

    /**
     * Enregistrement de la réclamation
     */
    saveReclamation () {
        this.$store.commit('reclamationOral/SET_ERROR', null) // reset de l'erreur potentiellement existante

        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }

        const params = {
            reclamation_id: this.reclamationSelectLocal.id,
            type: this.reclamationSelectLocal.type,
            payload: {
                message_gestionnaire: this.reclamationSelectLocal.message_gestionnaire,
                decision: this.reclamationSelectLocal.decision,
                submit: this.etat_avancement,
                reclamation_type_id: this.reclamation_type_id
            }
        }

        this.$bvToast.toast('Enregistrement en cours...', infosToaster)
        this.$store.dispatch('reclamationOral/updateReclamation', params)
            .then((response) => {
                // Maj de la réclamation
                this.reclamationSelectLocal.submitted_at = response.data.data.submitted_at
                this.reclamationSelectLocal.validated_at = response.data.data.validated_at
                this.reclamationSelectLocal.message_gestionnaire = response.data.data.message_gestionnaire
                this.reclamationSelectLocal.decision = response.data.data.decision
                this.reclamationSelectLocal.reclamatrionType = response.data.data.reclamatrionType
                this.reclamation_type_id = response.data.data.reclamatrionType.id

                this.getEtatAvancementReclamation()

                const idSucces = 't_succes_' + Math.random()
                const succesToaster = {
                    id: idSucces,
                    toaster: 'b-toaster-top-right',
                    variant: 'success',
                    noCloseButton: true,
                    fade: true,
                    autoHideDelay: 5000
                }
                this.$bvToast.toast('Enregistrement terminé', succesToaster)
            })
            .finally(() => {
                this.$bvToast.hide(idInfo)
            })
    }

    /** ouvre la modale de demande d'avis  */
    openDemanderUnAvis(open: boolean) {
        this.$store.commit('reclamationOral/SET_ERROR', null) // reset de l'erreur potentiellement existante
        this.showModalDemandeAvis = true
        this.open_avis = open
    }

    /** Confirmation de la demande d'avis à l'observateur */
    confirmerDemandeAvis() {
        this.$store.commit('reclamationOral/SET_ERROR', null) // reset de l'erreur potentiellement existante

        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }

        const params = {
            reclamation_id: this.reclamationSelectLocal.id,
            type: this.reclamationSelectLocal.type,
            payload: {
                etat: this.open_avis ? etat_avis.ETAT_PUBLIE_OBSERVATEUR : etat_avis.ETAT_CLOTURE_OBSERVATEUR
            }
        }

        this.$bvToast.toast('Enregistrement en cours...', infosToaster)
        this.$store.dispatch('reclamation/updateReclamation', params)
            .then((response) => {
                this.reclamationSelectLocal.etat = response.data.data.etat
                const idSucces = 't_succes_' + Math.random()
                const succesToaster = {
                    id: idSucces,
                    toaster: 'b-toaster-top-right',
                    variant: 'success',
                    noCloseButton: true,
                    fade: true,
                    autoHideDelay: 5000
                }
                this.$bvToast.toast('Enregistrement terminé', succesToaster)
                this.showModalDemandeAvis = false
            })
            .finally(() => {
                this.$bvToast.hide(idInfo)
            })
    }

    /** Annulation de la confirmation de la demande d'avis à l'observateur */
    cancelDemandeAvis() {
        this.$store.commit('reclamationOral/SET_ERROR', null) // reset de l'erreur potentiellement existante
        this.showModalDemandeAvis = false
    }

    /** Save un message dans la discussion */
    sendMessage () {
        this.$store.commit('reclamationOral/SET_ERROR', null) // reset de l'erreur potentiellement existante

        const payload = new FormData()
        payload.set('content', this.new_message)
        if (this.fileSingleFromInput) {
            payload.set('document', this.fileSingleFromInput)
        }

        this.$store.dispatch('reclamationOral/addMessage', { reclamation_id: this.reclamationSelectLocal.id, payload: payload }).then((response) => {
            // Maj de la reclamation select
            this.reclamationSelectLocal.messages = response.data.data.messages
            // Vide la zone de saisie de message
            this.new_message = ''
            this.fileSingleFromInput = null
            this.hasSelectedFile = false
            this.$nextTick(() => {
                const element = document.querySelector('.gestion_reclamation_oral_box_chat_message_display')
                if (element) {
                    element.scrollTop = element.scrollHeight
                }
            })
        }).catch((error) => {
            console.log('ko:' + error)
        })
    }

    /** Init datas */
    initDatas () {
        this.connected_user = this.$store.state.auth.user
        this.$store.dispatch('reclamationOral/getReclamation', Number(this.$route.params.reclamation_id)).then(() => {
            this.reclamationSelectLocal = this.$store.state.reclamationOral.reclamationOralSelect
            if (this.reclamationSelectLocal) {
                this.initInterface()
                this.$nextTick(() => {
                    const element = document.querySelector('.gestion_reclamation_oral_box_chat_message_display')
                    if (element) {
                        element.scrollTop = element.scrollHeight
                    }
                })
            }
        })
    }

    /** Ajoute un fichier au message */
    add_file_to_message (e: Event) {
        if (e.target !== null) {
            const target = e.target as HTMLInputElement
            const file: File = (target.files as FileList)[0]
            if (file) {
                this.fileSingleFromInput = file
                this.hasSelectedFile = true
                if (!this.new_message) { // on n'écrase pas l'éventuel message en cours de rédaction
                    this.new_message = 'Pièce jointe'
                }
            }
        }
    }

    /** Delete la pj */
    deleteFile () {
        this.fileSingleFromInput = null
        this.hasSelectedFile = false
    }

    /** Download Pj d'un message */
    dl_pj_message (message: any) {
        const params = { format: 'b64', reclamation_id: this.reclamationSelectLocal.id, message_id: message.id }
        const pdfFileName = message.documents[0].name

        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }
        this.$bvToast.toast('Téléchargement en cours ...', infosToaster)

        this.$store.dispatch('reclamationOral/dl_pj_message', params)
            .then(response => {
                const file_name = getFileNameFromHeader(response.headers) || pdfFileName
                const url = URL.createObjectURL(new Blob([base64ToArrayBuffer(response.data)]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('Download', file_name)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })
            .finally(() => {
                this.$bvToast.hide(idInfo)
            })
    }

    /** Retourne le libellé de l'état de la conversation avec l'observateur */
    getLibelleDiscussion (etat: etat_avis) {
        let libelle = '-'
        if (etat === etat_avis.ETAT_PUBLIE_OBSERVATEUR) {
            libelle = 'Un avis a été demandé à l\'observateur'
        } else if (etat === etat_avis.ETAT_NON_PUBLIEE) {
            libelle = 'Aucun avis n\'a été demandé à l\'observateur'
        } else if (etat === etat_avis.ETAT_CLOTURE_OBSERVATEUR) {
            libelle = 'La conversation avec l\'observateur est clôturée'
        }

        return libelle
    }

    mounted() {
        if (this.$store.state.ensemble.ensembles.length === 0) {
            this.$store.dispatch('ensemble/getEnsembles').then(() => {
                this.initDatas()
                const element = document.querySelector('.gestion_reclamation_oral_box_chat_message_display')
                if (element) {
                    element.scrollTop = element.scrollHeight
                }
            })
        } else {
            this.initDatas()
            const element = document.querySelector('.gestion_reclamation_oral_box_chat_message_display')
            if (element) {
                element.scrollTop = element.scrollHeight
            }
        }
    }
}

